module.exports = __webpack_public_path__ + "static/media/top-img-hub.82a0e53d.png";